import i18n from './i18n';
import {apiService} from "./services/api.service";

const loaded = new Set<string>();
const inflight = new Map<string, Promise<void>>();

export async function changeLanguageSafe(lng: string) {
    if (!lng) return;
    if (i18n.language === lng && loaded.has(lng)) return;

    if (!loaded.has(lng)) {
        const existing = inflight.get(lng);
        if (existing) {
            await existing;
        } else {
            const p = (async () => {
                const res = await apiService.getTranslations(lng);
                i18n.addResourceBundle(lng, 'translation', res.data, true, true);
                loaded.add(lng);
            })();
            inflight.set(lng, p);
            await p.finally(() => inflight.delete(lng));
        }
    }

    await i18n.changeLanguage(lng);
}